import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";

/*
  Generated class for the ApiForumProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiForumProvider {

  constructor(public http: HttpClient, public apiProvider: ApiProvider) {
    console.log('Hello ApiForumProvider Provider');
  }

  forumListPromise: Promise<any>;
  forumList: Array<any>;
  getForumList() {
    if(this.forumList) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(this.forumList);
        }, 100);
      });
    }


    if(this.forumListPromise) {
      return this.forumListPromise;
    }
    this.forumListPromise = this.apiProvider.callGet<Array<any>>("/forums", {itemsPerPage: 10}).toPromise().then(data => {
      this.forumList = data;
      console.log(data);
      return data;
    });
    return this.forumListPromise;
  }

  getForumTopics(forumId: string) {
    return this.apiProvider.callGet<Array<any>>('/forum_topics', {forum: forumId}).toPromise<Array<any>>();
  }

  getForumPosts(topicId: string) {
    return this.apiProvider.callGet<Array<any>>('/forum_posts', {forumTopic: topicId}).toPromise();
  }


  sendResponse(topicId: string, responseText: string, postId: string) {
    if(postId) {
      return this.apiProvider.callPut<any>('/forum_posts/'+postId, {forumTopic: '/api/forum_topics/'+topicId, text: responseText
      }).toPromise();
    }
    return this.apiProvider.callPost<any>('/forum_posts', {forumTopic: '/api/forum_topics/'+topicId, text: responseText
    }).toPromise();
  }


  createTopic(id: any, topic: { title: string; description: string, id: string }) {
    if(topic.id) {
      return this.apiProvider.callPut<any>('/forum_topics/'+topic.id, {forum: '/api/forums/'+id, title: topic.title, description:topic.description}).toPromise();
    }
    return this.apiProvider.callPost<any>('/forum_topics', {forum: '/api/forums/'+id, title: topic.title, description:topic.description}).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-forum/api-forum.ts